import { carouselItems } from '@/mocks/home';

const carouselImages: Record<string, string> = {
  'carousel-01': 'https://readdy.ai/api/search-image?query=Chinese%20comic%20art%20compilation%20featuring%20diverse%20characters%20from%20various%20Chinese%20manhua%20styles%20dynamic%20composition%20with%20vibrant%20warm%20orange%20and%20golden%20tones%20action%20adventure%20theme%20editorial%20illustration%20with%20dramatic%20lighting%20and%20manga%20panel%20layouts&width=600&height=360&seq=carousel-01&orientation=landscape',
  'carousel-02': 'https://readdy.ai/api/search-image?query=Intense%20action%20battle%20scene%20manga%20style%20illustration%20featuring%20powerful%20warriors%20clashing%20with%20energy%20effects%20fiery%20explosions%20against%20dark%20background%20warm%20orange%20red%20color%20palette%20dynamic%20anime%20composition%20with%20speed%20lines&width=600&height=360&seq=carousel-02&orientation=landscape',
  'carousel-03': 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20comic%20scene%20featuring%20detective%20character%20in%20shadowy%20urban%20alley%20with%20suspenseful%20atmosphere%20warm%20amber%20street%20lighting%20noir%20aesthetic%20manga%20style%20illustration%20with%20dramatic%20shadows%20and%20fog%20effects&width=600&height=360&seq=carousel-03&orientation=landscape',
  'carousel-04': 'https://readdy.ai/api/search-image?query=Romantic%20manga%20scene%20illustration%20featuring%20couple%20under%20cherry%20blossom%20tree%20with%20soft%20warm%20sunset%20lighting%20pink%20and%20peach%20tones%20dreamy%20atmosphere%20shojo%20anime%20art%20style%20with%20floating%20petals%20and%20gentle%20expressions&width=600&height=360&seq=carousel-04&orientation=landscape',
  'carousel-05': 'https://readdy.ai/api/search-image?query=Fantasy%20isekai%20manga%20scene%20featuring%20hero%20character%20in%20magical%20otherworld%20landscape%20with%20floating%20islands%20and%20mystical%20creatures%20warm%20golden%20orange%20sky%20epic%20adventure%20anime%20illustration%20style%20with%20detailed%20environment&width=600&height=360&seq=carousel-05&orientation=landscape',
};

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">精选专题</h2>
          <p className="text-sm md:text-base text-foreground-500">精心策划的漫画专题合辑，发现更多精彩内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {carouselItems.map((item) => (
            <a
              key={item.seq}
              href="#cards"
              className="flex flex-col bg-background-100 rounded-xl overflow-hidden hover:ring-2 hover:ring-primary-300 transition-all cursor-pointer group"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={carouselImages[item.seq]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-500 text-background-50 font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="font-semibold text-foreground-950 text-sm md:text-base mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}